import apiClient from '@/api/client'

export interface ClassEventResponse {
  id: string
  class_id: string
  topic: string
  notes?: string | null
  event_date?: string | null // YYYY-MM-DD or ISO
  is_recurring: boolean
  recurrence_rule?: string | null
  recurrence_series_id?: string | null // Shared across all events in one series
  attachment_ids?: string[] // Array of attachment UUIDs
  // Frontend convenience field
  starts_at?: string // ISO (derived from event_date)
}

export interface CreateEventPayload {
  class_id: string
  topic: string
  notes?: string | null
  event_date: string // YYYY-MM-DD
  is_recurring?: boolean
  recurrence_rule?: string | null
  recurrence_series_id?: string | null // Shared across all events in one series
  attachment_ids?: string[] // Array of attachment UUIDs
}

export const eventsApi = {
  async list(classId: string): Promise<ClassEventResponse[]> {
    const { data } = await apiClient.get(`/api/v1/events/class/${classId}`)
    // Transform to include starts_at for compatibility
    return Array.isArray(data) ? data.map((e: any) => ({
      ...e,
      starts_at: e.event_date ? new Date(e.event_date).toISOString() : undefined,
    })) : []
  },
  async create(payload: CreateEventPayload): Promise<ClassEventResponse> {
    const { data } = await apiClient.post('/api/v1/events/single', payload)
    return {
      ...data,
      starts_at: data.event_date ? new Date(data.event_date).toISOString() : undefined,
    }
  },
  async update(eventId: string, payload: Partial<CreateEventPayload>): Promise<ClassEventResponse> {
    const { data } = await apiClient.put(`/api/v1/events/${eventId}`, payload)
    return {
      ...data,
      starts_at: data.event_date ? new Date(data.event_date).toISOString() : undefined,
    }
  },
  async remove(eventId: string): Promise<{ ok: true }> {
    const { data } = await apiClient.delete(`/api/v1/events/${eventId}`)
    return data
  },
  /** One request for many events (only the fields given are changed). */
  async bulkUpdate(eventIds: string[], changes: { topic?: string; notes?: string; event_date?: string }): Promise<ClassEventResponse[]> {
    const { data } = await apiClient.put('/api/v1/events/bulk', { event_ids: eventIds, ...changes })
    return data
  },
  async updateSeries(eventId: string, payload: Partial<CreateEventPayload>): Promise<ClassEventResponse[]> {
    const { data } = await apiClient.put(`/api/v1/events/series/${eventId}`, payload)
    return Array.isArray(data) ? data.map((e: any) => ({
      ...e,
      starts_at: e.event_date ? new Date(e.event_date).toISOString() : undefined,
    })) : []
  },
}



